/**
 * NOYKA Locale Engine — Document Sync
 *
 * Updates <html lang="xx" dir="ltr|rtl"> when the locale changes.
 */

import { RTL_LANGUAGES } from './constants';

/** Apply lang and dir attributes to <html> */
export function applyDocumentLocale(locale: string): void {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = locale;
  document.documentElement.dir = (RTL_LANGUAGES as readonly string[]).includes(locale) ? 'rtl' : 'ltr';
}
